"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Input = require("../form/Input");

var _Input2 = _interopRequireDefault(_Input);

var _SubmitButton = require("../form/SubmitButton");

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangePasswordForm = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ChangePasswordForm, _Component);

  function ChangePasswordForm() {
    (0, _classCallCheck3.default)(this, ChangePasswordForm);
    return (0, _possibleConstructorReturn3.default)(this, (ChangePasswordForm.__proto__ || (0, _getPrototypeOf2.default)(ChangePasswordForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChangePasswordForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var reset_password_token = this.props.fields.reset_password_token;

      reset_password_token.onChange(this.props.passwordToken);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$fields = _props.fields,
          password = _props$fields.password,
          password2 = _props$fields.password2,
          reset_password_token = _props$fields.reset_password_token,
          handleSubmit = _props.handleSubmit,
          onSubmit = _props.onSubmit,
          auth = _props.auth;


      return _react2.default.createElement(
        "form",
        { id: "changePassword", onSubmit: handleSubmit(onSubmit) },
        _react2.default.createElement(
          "p",
          null,
          "Sy\xF6t\xE4 uusi salasana"
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          this.renderError(),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6 input-group" },
            _react2.default.createElement(
              _Input2.default,
              { id: "password", type: "password", label: "Salasana", fieldProps: password },
              _react2.default.createElement(
                "p",
                { className: "small" },
                "Salasanan tulee olla v\xE4hint\xE4\xE4n 8 merkki\xE4 pitk\xE4."
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "password2", type: "password", label: "Salasana uudelleen", fieldProps: password2 })
          ),
          _react2.default.createElement(_Input2.default, { id: "reset_password_token", type: "hidden", fieldProps: reset_password_token })
        ),
        _react2.default.createElement(_SubmitButton2.default, { text: "Vaihda", submitting: auth.changePasswordLoading || false })
      );
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var changePasswordError = this.props.auth.changePasswordError;

      if (changePasswordError) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "error-message error-text-js" },
            "Salasanan vaihto ep\xE4onnistui."
          )
        );
      }
    }
  }]);
  return ChangePasswordForm;
}(_react.Component), _class.propTypes = {
  handleSubmit: _react.PropTypes.func.isRequired,
  onSubmit: _react.PropTypes.func.isRequired,
  fields: _react.PropTypes.object.isRequired,
  auth: _react.PropTypes.object.isRequired,
  passwordToken: _react.PropTypes.string
}, _temp);
exports.default = ChangePasswordForm;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/password/ChangePasswordForm.js
 ** module id = 1168
 ** module chunks = 0
 **/